module.exports = __webpack_public_path__ + "img/icon_down_arrow.4fd0b398.svg";